import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const PrijsBerekenenPage = lazy(() => import('../pages/prijs-berekenen/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const WerkgebiedPage = lazy(() => import('../pages/werkgebied/page'));
const RobotsPage = lazy(() => import('../pages/robots/page'));

// Airport pages
const TaxiUtrechtSchipholPage = lazy(() => import('../pages/taxi-utrecht-schiphol/page'));
const TaxiUtrechtRotterdamPage = lazy(() => import('../pages/taxi-utrecht-rotterdam-airport/page'));
const TaxiUtrechtEindhovenPage = lazy(() => import('../pages/taxi-utrecht-eindhoven-airport/page'));

// Legal pages
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const CookiesPage = lazy(() => import('../pages/cookies/page'));
const AlgemeneVoorwaardenPage = lazy(() => import('../pages/algemene-voorwaarden/page'));

// City pages - Nieuwegein
const TaxiNieuwegeinSchipholPage = lazy(() => import('../pages/taxi-nieuwegein-schiphol/page'));
const TaxiNieuwegeinRotterdamPage = lazy(() => import('../pages/taxi-nieuwegein-rotterdam-airport/page'));
const TaxiNieuwegeinEindhovenPage = lazy(() => import('../pages/taxi-nieuwegein-eindhoven-airport/page'));

// City pages - Houten
const TaxiHoutenSchipholPage = lazy(() => import('../pages/taxi-houten-schiphol/page'));
const TaxiHoutenRotterdamPage = lazy(() => import('../pages/taxi-houten-rotterdam-airport/page'));
const TaxiHoutenEindhovenPage = lazy(() => import('../pages/taxi-houten-eindhoven-airport/page'));

// City pages - Zeist
const TaxiZeistSchipholPage = lazy(() => import('../pages/taxi-zeist-schiphol/page'));
const TaxiZeistRotterdamPage = lazy(() => import('../pages/taxi-zeist-rotterdam-airport/page'));
const TaxiZeistEindhovenPage = lazy(() => import('../pages/taxi-zeist-eindhoven-airport/page'));

// City pages - De Bilt
const TaxiDeBiltSchipholPage = lazy(() => import('../pages/taxi-de-bilt-schiphol/page'));
const TaxiDeBiltRotterdamPage = lazy(() => import('../pages/taxi-de-bilt-rotterdam-airport/page'));
const TaxiDeBiltEindhovenPage = lazy(() => import('../pages/taxi-de-bilt-eindhoven-airport/page'));

// City pages - Maarssen
const TaxiMaarssenSchipholPage = lazy(() => import('../pages/taxi-maarssen-schiphol/page'));
const TaxiMaarssenRotterdamPage = lazy(() => import('../pages/taxi-maarssen-rotterdam-airport/page'));
const TaxiMaarssenEindhovenPage = lazy(() => import('../pages/taxi-maarssen-eindhoven-airport/page'));

// City pages - Soest
const TaxiSoestSchipholPage = lazy(() => import('../pages/taxi-soest-schiphol/page'));
const TaxiSoestRotterdamPage = lazy(() => import('../pages/taxi-soest-rotterdam-airport/page'));
const TaxiSoestEindhovenPage = lazy(() => import('../pages/taxi-soest-eindhoven-airport/page'));

// City pages - Vianen
const TaxiVianenSchipholPage = lazy(() => import('../pages/taxi-vianen-schiphol/page'));
const TaxiVianenRotterdamPage = lazy(() => import('../pages/taxi-vianen-rotterdam-airport/page'));
const TaxiVianenEindhovenPage = lazy(() => import('../pages/taxi-vianen-eindhoven-airport/page'));

// City pages - IJsselstein
const TaxiIJsselsteinSchipholPage = lazy(() => import('../pages/taxi-ijsselstein-schiphol/page'));
const TaxiIJsselsteinRotterdamPage = lazy(() => import('../pages/taxi-ijsselstein-rotterdam-airport/page'));
const TaxiIJsselsteinEindhovenPage = lazy(() => import('../pages/taxi-ijsselstein-eindhoven-airport/page'));

// City pages - Breukelen
const TaxiBreukelenSchipholPage = lazy(() => import('../pages/taxi-breukelen-schiphol/page'));
const TaxiBreukelenRotterdamPage = lazy(() => import('../pages/taxi-breukelen-rotterdam-airport/page'));
const TaxiBreukelenEindhovenPage = lazy(() => import('../pages/taxi-breukelen-eindhoven-airport/page'));

// City pages - Woerden
const TaxiWoerdenSchipholPage = lazy(() => import('../pages/taxi-woerden-schiphol/page'));
const TaxiWoerdenRotterdamPage = lazy(() => import('../pages/taxi-woerden-rotterdam-airport/page'));
const TaxiWoerdenEindhovenPage = lazy(() => import('../pages/taxi-woerden-eindhoven-airport/page'));

// City pages - Amersfoort
const TaxiAmersfoortSchipholPage = lazy(() => import('../pages/taxi-amersfoort-schiphol/page'));
const TaxiAmersfoortRotterdamPage = lazy(() => import('../pages/taxi-amersfoort-rotterdam-airport/page'));
const TaxiAmersfoortEindhovenPage = lazy(() => import('../pages/taxi-amersfoort-eindhoven-airport/page'));

// City pages - Bunnik
const TaxiBunnikSchipholPage = lazy(() => import('../pages/taxi-bunnik-schiphol/page'));
const TaxiBunnikRotterdamPage = lazy(() => import('../pages/taxi-bunnik-rotterdam-airport/page'));
const TaxiBunnikEindhovenPage = lazy(() => import('../pages/taxi-bunnik-eindhoven-airport/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/robots.txt',
    element: <RobotsPage />,
  },
  {
    path: '/prijs-berekenen',
    element: <PrijsBerekenenPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/werkgebied',
    element: <WerkgebiedPage />,
  },
  {
    path: '/taxi-utrecht-schiphol',
    element: <TaxiUtrechtSchipholPage />,
  },
  {
    path: '/schiphol-taxi-utrecht',
    element: <TaxiUtrechtSchipholPage />,
  },
  {
    path: '/taxi-utrecht-rotterdam-airport',
    element: <TaxiUtrechtRotterdamPage />,
  },
  {
    path: '/taxi-utrecht-eindhoven-airport',
    element: <TaxiUtrechtEindhovenPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/cookies',
    element: <CookiesPage />,
  },
  {
    path: '/algemene-voorwaarden',
    element: <AlgemeneVoorwaardenPage />,
  },
  // Nieuwegein
  {
    path: '/taxi-nieuwegein-schiphol',
    element: <TaxiNieuwegeinSchipholPage />,
  },
  {
    path: '/taxi-nieuwegein-rotterdam-airport',
    element: <TaxiNieuwegeinRotterdamPage />,
  },
  {
    path: '/taxi-nieuwegein-eindhoven-airport',
    element: <TaxiNieuwegeinEindhovenPage />,
  },
  // Houten
  {
    path: '/taxi-houten-schiphol',
    element: <TaxiHoutenSchipholPage />,
  },
  {
    path: '/taxi-houten-rotterdam-airport',
    element: <TaxiHoutenRotterdamPage />,
  },
  {
    path: '/taxi-houten-eindhoven-airport',
    element: <TaxiHoutenEindhovenPage />,
  },
  // Zeist
  {
    path: '/taxi-zeist-schiphol',
    element: <TaxiZeistSchipholPage />,
  },
  {
    path: '/taxi-zeist-rotterdam-airport',
    element: <TaxiZeistRotterdamPage />,
  },
  {
    path: '/taxi-zeist-eindhoven-airport',
    element: <TaxiZeistEindhovenPage />,
  },
  // De Bilt
  {
    path: '/taxi-de-bilt-schiphol',
    element: <TaxiDeBiltSchipholPage />,
  },
  {
    path: '/taxi-de-bilt-rotterdam-airport',
    element: <TaxiDeBiltRotterdamPage />,
  },
  {
    path: '/taxi-de-bilt-eindhoven-airport',
    element: <TaxiDeBiltEindhovenPage />,
  },
  // Maarssen
  {
    path: '/taxi-maarssen-schiphol',
    element: <TaxiMaarssenSchipholPage />,
  },
  {
    path: '/taxi-maarssen-rotterdam-airport',
    element: <TaxiMaarssenRotterdamPage />,
  },
  {
    path: '/taxi-maarssen-eindhoven-airport',
    element: <TaxiMaarssenEindhovenPage />,
  },
  // Soest
  {
    path: '/taxi-soest-schiphol',
    element: <TaxiSoestSchipholPage />,
  },
  {
    path: '/taxi-soest-rotterdam-airport',
    element: <TaxiSoestRotterdamPage />,
  },
  {
    path: '/taxi-soest-eindhoven-airport',
    element: <TaxiSoestEindhovenPage />,
  },
  // Vianen
  {
    path: '/taxi-vianen-schiphol',
    element: <TaxiVianenSchipholPage />,
  },
  {
    path: '/taxi-vianen-rotterdam-airport',
    element: <TaxiVianenRotterdamPage />,
  },
  {
    path: '/taxi-vianen-eindhoven-airport',
    element: <TaxiVianenEindhovenPage />,
  },
  // IJsselstein
  {
    path: '/taxi-ijsselstein-schiphol',
    element: <TaxiIJsselsteinSchipholPage />,
  },
  {
    path: '/taxi-ijsselstein-rotterdam-airport',
    element: <TaxiIJsselsteinRotterdamPage />,
  },
  {
    path: '/taxi-ijsselstein-eindhoven-airport',
    element: <TaxiIJsselsteinEindhovenPage />,
  },
  // Breukelen
  {
    path: '/taxi-breukelen-schiphol',
    element: <TaxiBreukelenSchipholPage />,
  },
  {
    path: '/taxi-breukelen-rotterdam-airport',
    element: <TaxiBreukelenRotterdamPage />,
  },
  {
    path: '/taxi-breukelen-eindhoven-airport',
    element: <TaxiBreukelenEindhovenPage />,
  },
  // Woerden
  {
    path: '/taxi-woerden-schiphol',
    element: <TaxiWoerdenSchipholPage />,
  },
  {
    path: '/taxi-woerden-rotterdam-airport',
    element: <TaxiWoerdenRotterdamPage />,
  },
  {
    path: '/taxi-woerden-eindhoven-airport',
    element: <TaxiWoerdenEindhovenPage />,
  },
  // Amersfoort
  {
    path: '/taxi-amersfoort-schiphol',
    element: <TaxiAmersfoortSchipholPage />,
  },
  {
    path: '/taxi-amersfoort-rotterdam-airport',
    element: <TaxiAmersfoortRotterdamPage />,
  },
  {
    path: '/taxi-amersfoort-eindhoven-airport',
    element: <TaxiAmersfoortEindhovenPage />,
  },
  // Bunnik
  {
    path: '/taxi-bunnik-schiphol',
    element: <TaxiBunnikSchipholPage />,
  },
  {
    path: '/taxi-bunnik-rotterdam-airport',
    element: <TaxiBunnikRotterdamPage />,
  },
  {
    path: '/taxi-bunnik-eindhoven-airport',
    element: <TaxiBunnikEindhovenPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
